import { useContext } from 'react';
import { RootContext } from '../context/RootContext';
export default function useAuth() {
  const { auth, dispatch } = useContext(RootContext);

  if (auth && auth.isLoggedIn) {
    return true;
  } else {
    let sessionFdState = localStorage.getItem('citriot');

    if (sessionFdState) {
      sessionFdState = JSON.parse(sessionFdState);
      const { auth: { user } } = sessionFdState;
      dispatch({ type: 'LOGIN', user});
      return true;
    } else {
      return false;
    }
  }
}
